import React from 'react';
import CatalogLandingPage from './pages/CatalogLandingPage';

export const catalogPublicRoutes = [
  {
    path: '/catalog/landing-page/:workspaceId/:catalogSlug',
    element: <CatalogLandingPage />,
  },
];
